import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'form-group-repeat-section',
    template: `
		<div *ngFor="let field of field.fieldGroup; let i = index">
			<formly-group [field]="field"></formly-group>
		</div>
	`,
    standalone: true,
    imports: [NgFor, FormlyModule],
})
export class FormGroupRepeatComponent extends FieldArrayType {}
